import { KybDocument, OnboardingCompanyProfile } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Card from 'components/_core/Card';
import OBFileItem from 'features/Onboarding/components/OBFileItem';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import MandateeHeader from '../../components/Header';
import locales from './locales';

interface MandateReviewProps {
  onContinue: () => void;
  onDelete: (documentId: string) => void;
  isDeleting: boolean;
  companyProfile: Pick<OnboardingCompanyProfile, 'legalName'>;
  mandateDocument?: Pick<KybDocument, 'kybDocumentId' | 'url'>;
}

const MandateReview = asBentoPage<MandateReviewProps>(
  ({
    companyProfile,
    isDeleting,
    Layout,
    mandateDocument,
    onContinue,
    onDelete,
    onPrev,
  }) => {
    return (
      <Layout nav={<OBNavigation onPrev={isDeleting ? undefined : onPrev} />}>
        <MandateeHeader legalName={companyProfile.legalName} />

        <Card.Group>
          <Card>
            {/* document can be undefined at the end of the DELETE state */}
            {mandateDocument ? (
              <OBFileItem
                fileName={locales.documentName}
                isLoading={isDeleting}
                onDeleteClick={() => onDelete(mandateDocument.kybDocumentId)}
                onPreviewClick={() =>
                  mandateDocument.url &&
                  window.open(mandateDocument.url, '_blank')
                }
              />
            ) : null}
          </Card>
          <Card>
            <Button isDisabled={isDeleting} isExpanded onClick={onContinue}>
              {locales.continue}
            </Button>
          </Card>
        </Card.Group>
      </Layout>
    );
  },
);

export default MandateReview;
